'use strict';
var React = require('react');
module.exports = function () {
    function onClick1() {
        this.props.toggleContactUs();
    }
    function onChange2(e) {
        this.handleChange(e);
    }
    function onChange3(e) {
        this.handleChange(e);
    }
    function onChange4(e) {
        this.handleChange(e);
    }
    function onChange5(e) {
        this.handleChange(e);
    }
    function onChange6(e) {
        this.handleChange(e);
    }
    function onClick7(event) {
        this.onContactUsSubmit(event);
    }
    return React.createElement('div', { 'className': 'contact-us-wrapper' }, React.createElement('div', {
        'className': 'contact-us-container',
        'id': 'contact-us-container'
    }, React.createElement('div', { 'className': 'header-close-button' }, React.createElement('span', { 'className': 'contact-us-header' }, 'Contact Us'), React.createElement('div', {
        'className': 'contact-us-close-button',
        'onClick': onClick1.bind(this)
    })), React.createElement('form', { 'className': 'contact-us-form-wrapper' }, React.createElement('div', { 'className': 'input-box-container' }, React.createElement('input', {
        'className': 'contact-us-input-box name-input-box',
        'name': 'name',
        'type': 'text',
        'placeholder': 'Name',
        'onChange': onChange2.bind(this),
        'required': true
    }), React.createElement('input', {
        'className': 'contact-us-input-box',
        'name': 'email',
        'type': 'email',
        'placeholder': 'Email',
        'onChange': onChange3.bind(this),
        'required': true
    })), React.createElement('div', { 'className': 'input-box-container' }, React.createElement('input', {
        'className': 'contact-us-input-box name-input-box',
        'name': 'company_name',
        'type': 'text',
        'placeholder': 'Company',
        'onChange': onChange4.bind(this),
        'required': true
    }), React.createElement('input', {
        'className': 'contact-us-input-box',
        'name': 'mobile_number',
        'type': 'tel',
        'pattern': '^[0-9\\-\\+]*$',
        'placeholder': 'Mobile',
        'onChange': onChange5.bind(this),
        'required': true
    })), React.createElement('textarea', {
        'className': 'contact-us-input-box',
        'name': 'message',
        'placeholder': 'Message',
        'onChange': onChange6.bind(this),
        'required': true
    }), React.createElement('button', {
        'className': 'buy-metype-submit-button',
        'type': 'submit',
        'onClick': onClick7.bind(this)
    }, 'submit'))));
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/pages/metype_home/contact_form_modal.rt
// module id = 895
// module chunks = 7